<div class="email-attachments">

    <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
        <button type="button" class="btn btn-ms-secondary" (click)="openFilePicker()">
            <fa-duotone-icon icon="folder-open" class="me-2" secondaryOpacity="0.9" />
            Attach from Document Center
        </button>
        <button type="button" class="btn btn-ms-secondary" (click)="triggerFileInput()">
            <fa-duotone-icon icon="arrow-up-from-bracket" class="me-2" secondaryOpacity="0.9" />
            Upload from device
        </button>

        <span class="text-muted small ms-auto">
            {{ formatBytes(totalBytes()) }} of {{ maxTotalLabel }} used
        </span>
    </div>

    <!-- Hidden native picker for device uploads. -->
    <input #fileInput type="file" multiple class="d-none" (change)="onDeviceFilesSelected($event)" />

    <!-- Upload target -->
    <div class="d-flex align-items-center flex-wrap gap-2 mb-1">
        <span class="text-muted small">
            Uploads are saved to <span class="fw-semibold">{{ targetFolderName() }}</span>.
        </span>
        <button type="button" class="btn btn-ms-secondary btn-sm" (click)="openChangeFolder()">
            <fa-duotone-icon icon="folder" class="me-1" secondaryOpacity="0.9" />
            Change folder
        </button>
    </div>
    <p class="text-muted small">{{ storageNote }}</p>

    @if (errorMessage()) {
        <div class="alert alert-warning d-flex align-items-center gap-2 py-2" role="alert">
            <fa-duotone-icon icon="triangle-exclamation" class="text-warning flex-shrink-0" secondaryOpacity="0.4" />
            <div class="small">{{ errorMessage() }}</div>
        </div>
    }

    <!-- Committed attachments -->
    @if (hasAttachments()) {
        <ul class="list-group mb-2">
            @for (attachment of attachments(); track attachment.documentId) {
                <li class="list-group-item d-flex align-items-center gap-2">
                    <fa-duotone-icon icon="paperclip" secondaryOpacity="0.9" />
                    <span class="text-truncate flex-grow-1">{{ attachment.name }}</span>
                    @if (attachment.status === DocumentStatus.Pending) {
                        <span class="badge text-bg-light">Scanning</span>
                    }
                    <span class="small text-muted">{{ formatBytes(attachment.sizeBytes) }}</span>
                    <button type="button" class="remove-attachment ms-1" aria-label="Remove attachment"
                        (click)="removeAttachment(attachment.documentId)">
                        <fa-duotone-icon icon="xmark" secondaryOpacity="1" />
                    </button>
                </li>
            }
        </ul>
    }

    <!-- In-flight device uploads -->
    @for (item of activeUploads(); track item.tempId) {
        <div class="d-flex align-items-center gap-2 small text-muted mb-1">
            <span class="spinner-border spinner-border-sm"></span>
            <span class="text-truncate flex-grow-1">{{ item.fileName }}</span>
            <span>{{ item.status === DocumentUploadStatus.Uploading ? item.percent + '%' : 'Queued' }}</span>
        </div>
    }

    <!-- Failed device uploads -->
    @for (item of failedUploads(); track item.tempId) {
        <div class="alert alert-danger d-flex align-items-center gap-2 py-2 mb-1" role="alert">
            <fa-duotone-icon icon="circle-exclamation" class="text-danger flex-shrink-0" secondaryOpacity="0.4" />
            <div class="small flex-grow-1">
                <span class="fw-semibold">{{ item.fileName }}</span> — {{ item.errorMessage }}
            </div>
            @if (item.retryable !== false) {
                <button type="button" class="btn btn-link p-0 small" (click)="retryUpload(item.tempId)">Retry</button>
            }
            <button type="button" class="btn btn-link text-muted p-0 small" (click)="dismissUpload(item.tempId)">Dismiss</button>
        </div>
    }

    <!-- Attach-from-Document-Center picker -->
    <ms-document-file-picker
        [modalId]="filePickerModalId"
        title="Attach a file from Document Center"
        helpText="Choose a folder, then select a file."
        confirmLabel="Attach"
        (fileSelected)="onDocumentPicked($event)" />

    <!-- Change upload folder -->
    <div class="modal fade" [id]="uploadFolderModalId" msEscClose (escPressed)="closeChangeFolder()"
        data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header border-0 p-4">
                    <h5 class="modal-title">Choose a folder for uploads</h5>
                </div>
                <div class="modal-body px-4 pb-0">
                    <p class="text-secondary small mb-3">
                        Uploaded attachments will be saved to the folder you choose in your Document Center.
                    </p>
                    @if (isLoadingUploadFolders()) {
                        <div class="d-flex align-items-center gap-2 text-muted small py-2">
                            <span class="spinner-border spinner-border-sm"></span> Loading folders…
                        </div>
                    } @else {
                        <ms-folder-tree-picker
                            [rootNodes]="uploadFolderTree()"
                            [loadChildren]="loadUploadFolderChildren"
                            [(selected)]="selectedUploadFolder"
                            [showRoot]="false"
                            emptyMessage="No folders available." />
                    }
                </div>
                <div class="modal-footer border-0 d-flex justify-content-center pb-4 gap-2">
                    <button type="button" class="btn btn-ms-secondary px-4" (click)="closeChangeFolder()">Cancel</button>
                    <button type="button" class="btn btn-primary px-4" (click)="confirmUploadFolder()" [disabled]="!canApplyUploadFolder()">
                        @if (isApplyingUploadFolder()) {
                            <span class="spinner-border spinner-border-sm me-2"></span>
                        }
                        Use this folder
                    </button>
                </div>
            </div>
        </div>
    </div>

</div>
